import { FC } from 'react'
import styled from 'styled-components'
import { ASharedModal, SharedModalContent, SharedModalTitle } from 'views/components/SharedModal'
import { useTranslation } from 'react-i18next'
import { SamplePartsTabs } from './SamplePartsTabs'
import { SamplePartsTab } from '../../types'

export const FullScreenContent = styled(SharedModalContent)`
  max-height: calc(100dvh - 200px);
  position: relative;
`

type Props = {
  data: SamplePartsTab[]
  sampleId: number
  onClose: () => void
}
export const SamplePartsFullScreen: FC<Props> = ({ data, onClose, sampleId }) => {
  const { t } = useTranslation('samples')
  return (
    <ASharedModal id="samplePartsFullScreenModal" size="fullScreen" onClose={onClose}>
      <SharedModalTitle>{t('analysisResults')}</SharedModalTitle>
      <FullScreenContent>
        {data.length === 0 && 'No Data'}
        <SamplePartsTabs data={data} sampleId={sampleId} isFullScreen />
      </FullScreenContent>
    </ASharedModal>
  )
}
